import { render } from "./LuckyBagRain.vue?vue&type=template&id=4799050c&scoped=true"
import script from "./LuckyBagRain.vue?vue&type=script&lang=js"
export * from "./LuckyBagRain.vue?vue&type=script&lang=js"

import "./LuckyBagRain.vue?vue&type=style&index=0&id=4799050c&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4799050c"]])

export default __exports__